/**
 * Shared primitives for pricing Zod schemas (SCRUM-158 / P-8).
 *
 * This file is an intra-package helper — NOT exported from the public barrel.
 * Consumers import from the aggregate files (season-group.ts, etc.).
 */
import { z } from 'zod';
import { LocalDateSchema } from '../time/index.js';
// ---------------------------------------------------------------------------
// isoLocalDateString — validated YYYY-MM-DD date string
// Re-used by every pricing schema that carries date range fields.
// ---------------------------------------------------------------------------
export const isoLocalDateString = z
    .string()
    .refine((s) => LocalDateSchema.safeParse(s).success, {
    message: 'must be a valid ISO-8601 calendar date (YYYY-MM-DD)',
});
// ---------------------------------------------------------------------------
// instantString — validated ISO-8601 datetime with Z suffix
// ---------------------------------------------------------------------------
export const instantString = z.string().datetime({ offset: false });
// ---------------------------------------------------------------------------
// centsSchema — safe-integer non-negative number
// ---------------------------------------------------------------------------
export const centsSchema = z
    .number()
    .int()
    .nonnegative()
    .max(Number.MAX_SAFE_INTEGER);
//# sourceMappingURL=_shared.js.map